/*
 * Chakra theme defaults
 *
 * This file should contain base styles that apply to ALL meetings
 * Essentially the default theme for all meetings
 */

import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react"

import fonts from "./fonts"
import breakpoints from "./breakpoints"
import textStyles from "./textStyles"
import globalCss from "./globalsCss"
import fontSizes from "./fontSizes"
import recipes from "./recipes"
import slotRecipes from "./slotRecipes"

export default function makeTheme(siteTheme) {
    // Site palettes come from Craft and may leave some slots empty. Chakra 3.37+ walks every token
    // value while merging configs and throws on null, so only emit tokens for colors that are set.
    const palette = siteTheme.colorPalette?.[0] || {}
    const colors = {}
    for (let i = 1; i <= 16; i++) {
        const value = palette[`color${i}`]
        if (value) colors[`color${i}`] = { value }
    }
    Object.assign(colors, {
        tctmdred: { value: "#ac0034" }, // var(--chakra-colors-tctmdred)
        red: {
            DEFAULT: { value: "#ea002a" },
        },
        yellow: { value: "#F3BD00" },
        error: { value: "#C53030" },
        // Override default gray palette with subtle cool gray
        gray: {
            50: { value: "#f8fafc" },
            100: { value: "#f1f5f9" },
            200: { value: "#e2e8f0" },
            300: { value: "#cbd5e1" },
            400: { value: "#94a3b8" },
            500: { value: "#64748b" },
            600: { value: "#475569" },
            700: { value: "#334155" },
            800: { value: "#1e293b" },
            900: { value: "#0f172a" },
            950: { value: "#020617" },
        },
    })

    const config = defineConfig({
        disableLayers: false,
        preflight: true,
        globalCss: globalCss,
        theme: {
            breakpoints,
            recipes: recipes,
            slotRecipes: slotRecipes,
            textStyles,
            tokens: {
                config: {
                    initialColorMode: "light",
                    useSystemColorMode: false,
                },
                fonts,
                fontSizes,
                colors,
                sizes: {
                    largeSizes: {
                        sm: { value: "640px" },
                        md: { value: "768px" },
                        lg: { value: "1024px" },
                        xl: { value: "1280px" },
                    },
                    header: {
                        h: { value: "62px" },
                    },
                },
            },
            // original
            // header: {
            //     h: { base: "44px", md: "62px" },
            // },
            // backgroundImage: siteTheme.backgroundImage,
        },
    })

    return createSystem(defaultConfig, config)
}
